import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import {
  ActiveErrorsStore,
  InstallationDetailsStore,
  Platform,
  RemoteDiagnosticsStore,
} from '@store';

import { PaidFeaturesEnum } from '../../../../../shared/pipes/paid-feature-available/paid-feature-available.pipe';
import { ActiveErrorDetailsSections } from '../guided-troubleshooting.model';

@Component({
  selector: 'app-active-error-details',
  templateUrl: './active-error-details.component.html',
  styleUrls: ['./active-error-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveErrorDetailsComponent {
  readonly GTS = PaidFeaturesEnum.GuidedTroubleshooting;
  readonly platform = Platform;
  readonly subscriptionPlan = SubscriptionPlan;
  readonly activeErrorDetailsSections = ActiveErrorDetailsSections;

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    public installationDetailsStore: InstallationDetailsStore,
    public remoteDiagnosticsStore: RemoteDiagnosticsStore
  ) {}
}
